import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["assetSection", "uploadSection", "contentSourceType", "bookSelect", "assetSelect", "contentSourceCard"]

  // Editing works from the existing question bank — the content source (for pulling
  // source material to generate from) is irrelevant, so hide it in edit mode.
  modeChanged(event) {
    const editing = event.target.value === "edit"
    if (this.hasContentSourceCardTarget) {
      this.contentSourceCardTarget.style.display = editing ? "none" : "block"
    }
  }

  contentModeChanged(event) {
    const mode = event.target.value

    this.assetSectionTarget.style.display = mode === "asset" ? "block" : "none"
    this.uploadSectionTarget.style.display = mode === "upload" ? "block" : "none"

    if (this.hasContentSourceTypeTarget) {
      if (mode === "asset") {
        this.contentSourceTypeTarget.value = "book_asset"
      } else if (mode === "upload") {
        this.contentSourceTypeTarget.value = "upload"
      } else {
        this.contentSourceTypeTarget.value = ""
      }
    }
  }

  async bookChanged(event) {
    const bookId = event.target.value
    if (!bookId) return

    const response = await fetch(`/exercise/question_generations/assets?book_id=${bookId}`, {
      headers: { "Accept": "application/json" }
    })
    const assets = await response.json()

    const select = this.assetSelectTarget
    select.innerHTML = '<option value="">Select an asset...</option>'
    assets.forEach(asset => {
      const option = document.createElement("option")
      option.value = asset.id
      option.textContent = asset.name || asset.title
      select.appendChild(option)
    })
  }
}
